import React, { memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const t = {
  estimated: 'Estimated',
};

const StageEstimatedTime = ({ clickable, retrievedTime, travelTime, className }) => {
  if (!travelTime || !clickable) {
    return null;
  }

  const now = moment(retrievedTime);
  const estimated = now.add(travelTime, 'seconds');

  return (
    <div className={className}>
      {t.estimated} - {estimated.format('HH:mm')}
    </div>
  );
};

StageEstimatedTime.propTypes = {
  className: PropTypes.string,
  retrievedTime: PropTypes.number,
  travelTime: PropTypes.number,
  clickable: PropTypes.bool,
};

export default memo(StageEstimatedTime);
